export const environment = {
  production: false,
  backendURL: 'https://railmen.fuzztest.org',
};
